export default [
  {
    text: 'Status view with 4 steps',
    description: 'Default layout.',
    images: true,
    value: '4-step'
  },
  {
    text: 'Custom status view',
    description: 'Enter config file for a view-cell-warpper.',
    images: false,
    value: 'config-dync-appshop-status-layout.json'
  }
];
